import { render, staticRenderFns } from "./ViewStaff.vue?vue&type=template&id=3a0e26ec"
import script from "./ViewStaff.vue?vue&type=script&lang=js"
export * from "./ViewStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports